import React from 'react'

import NavbarItem from '../components/NavItem/NavbarItem'

const useNavItems = (links, scroll) => {
  const navItems = links.map(function (link) {
    if (link.pageReference === null && link.slug === null) return
    return (
      <NavbarItem
        key={link.id}
        links={link.subNavigationItems}
        name={link.name}
        slug={link.pageReference?.slug ?? link.slug}
        scroll={scroll}
      />
    )
  })
  return [navItems]
}

export default useNavItems
